import { cEl } from '../../../../../util';
import { navigateTo } from '../../../../AppHeader/Link';
import { PATH_CONTACT } from '../../../../path';

function TestResultFooter() {
    const footer = cEl('div');
    footer.classList.add('test-result-footer');
    footer.innerHTML = `<div>더 자세한 내용이 궁금한가요?</div>`;

    const contactButton = cEl('button');
    contactButton.classList.add('button', 'brand-button');
    contactButton.innerHTML = '문의하기';
    contactButton.addEventListener('click', e => {
        navigateTo(PATH_CONTACT);
    });

    footer.appendChild(contactButton);
    return footer;
}

export default TestResultFooter;
